import React from 'react';
import '../Styles/Home.css';

const Footer = () => {
  return (
    <footer className="pt-8">
      <div className="mx-auto px-4">
        <div className="flex flex-col md:flex-row md:flex-wrap gap-0 md:gap-4 justify-between mb-4">
          <div>
            <a href='/' className='flex justify-center'><img src='/assets/img/Logo/Logo.svg'></img></a>
            {/*
            <p className="text-gray-400 text-center mt-2">BE PART OF OUR COMMUNITY</p>
            <div className='flex justify-around'>
              <button className='brands-icon'><i className='fa-brands fa-x-twitter'></i></button>
              <button className='brands-icon'><i className='fa-brands fa-linkedin'></i></button>
              <button className='brands-icon'><i class="fa-solid fa-paper-plane"></i></button>
              <button className='brands-icon'><i className='fa-brands fa-youtube'></i></button>
              <button className='brands-icon'><i className='fa-brands fa-discord'></i></button>
            </div>*/}
          </div>

          <div>
            <h4 className="wallet-top text-lg font-semibold mb-4">Wallet</h4>
            <ul className="space-y-2">
              <li><a href="#" className="footer-links">Mobile App</a></li>
              <li><a href="#" className="footer-links">Browser Extension</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Features</h4>
            <ul className="space-y-2">
              <li><a href="#" className="footer-links">Buy Crypto</a></li>
              <li><a href="#" className="footer-links">Swaps</a></li>
              <li><a href="#" className="footer-links">Staking</a></li>
              <li><a href="#" className="footer-links">NFTs</a></li>
              <li><a href="#" className="footer-links">Security</a></li>
              <li><a href="#" className="footer-links text-wrap">SWIFT: Smart Contract Wallet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Build</h4>
            <ul className="space-y-2">
              <li><a href="#" className="footer-links">Developer Docs</a></li>
              <li><a href="#" className="footer-links">Wallet Core</a></li>
              <li><a href="#" className="footer-links">Submit dApp</a></li>
              <li><a href="#" className="footer-links">Get assets listed</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              {/*<li><a href="#" className="footer-links">FAQ</a></li>
              <li><a href="#" className="footer-links">Community Forum</a></li>*/}
              <li><a href="#" className="footer-links">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Build</h4>
            <ul className="space-y-2">
              <li><a href="#" className="footer-links">About Us</a></li>
              <li><a href="/terms-condition" target='_blank' className="footer-links">Terms of Service</a></li>
              <li><a href="/privacy-policy" target='_blank' className="footer-links">Privacy Policy</a></li>
              <li><a href="#" className="footer-links">Blog</a></li>
            </ul>
          </div>
          <div>
            <img src='/assets/img/Vector.svg' className='mx-auto'></img>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="text-[#8C87A6] text-left font-medium">
              <p> © All rights reserved to ZoidPay</p>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;